import React from "react";
import { formatScheduleRange, matchEndTime } from "@/components/manage/scheduleTimeline";

export default function ScheduleTimeRange({ match, tournament }) {
  if (!match.scheduled_time) return <span>Set start time</span>;
  const range = formatScheduleRange(match.scheduled_time, matchEndTime(match, tournament), tournament.timezone);
  return (
    <span className="block text-left leading-snug">
      <span className="block text-[10px] text-muted-foreground">{range.date}</span>
      <span className="block">{range.time}</span>
      <span className="block text-[10px] text-muted-foreground">{range.offset}</span>
    </span>
  );
}

export function ScheduleBreak({ pause, tournament, showField = false }) {
  const range = formatScheduleRange(pause.start, pause.end, tournament.timezone);
  const field = (tournament.fields || []).find((entry) => entry.id === pause.fieldId)?.name || "Field";
  return (
    <div className="rounded border-y-2 border-purple-500 bg-purple-100 px-2 py-1 text-xs text-purple-900 dark:bg-purple-950/50 dark:text-purple-200"
      data-testid={pause.id}>
      <div className="font-semibold">Break · {pause.minutes} min{showField ? ` · ${field}` : ""}</div>
      <div className="text-[10px]">{range.time}</div>
      <div className="text-[10px]">{range.offset}</div>
    </div>
  );
}
